import { registerGlobal } from "../../common/registerGlobal.ts";
import { bySport } from "../../common/sportFunctions.ts";
import advStatsBaseball from "./advStats.baseball.ts";
import advStatsBasketball from "./advStats.basketball.ts";
import advStatsFootball from "./advStats.football.ts";
import advStatsHockey from "./advStats.hockey.ts";

export const advStats = () => {
	return bySport({
		baseball: advStatsBaseball(),
		basketball: advStatsBasketball(),
		football: advStatsFootball(),
		hockey: advStatsHockey(),
	});
};

registerGlobal({ advStats });
